import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { API_BASE_URL } from '../tokens/api-base-url';
import { isNuestroApiUrl } from '../utils/api-url.util';
import { isPublicAuthApiUrl } from '../utils/public-auth-url';

/** Añade JWT solo en peticiones a nuestro API. FactuConect usa el header `client-token`. */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const apiBase = inject(API_BASE_URL);
  const token = auth.getToken();
  const url = req.url;

  if (!token || isPublicAuthApiUrl(url) || !isNuestroApiUrl(url, apiBase)) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    }),
  );
};
